import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

// Bitácora de errores reales de la app — se guarda uno por cada error de
// render, de JS o de promesa sin atrapar, para poder revisarlos en el
// módulo Historial sin depender de que alguien lo reporte a mano.
export async function registrarError({ mensaje, stack, tipo, usuario }) {
  try {
    await addDoc(collection(db, "errores_app"), {
      mensaje: String(mensaje || "").slice(0, 500),
      stack: String(stack || "").slice(0, 2000),
      tipo: tipo || "js",
      pagina: window.location.pathname,
      usuarioEmail: usuario?.email || "",
      usuarioNombre: usuario?.nombre || usuario?.email || "Desconocido",
      userAgent: navigator.userAgent,
      fecha: new Date()
    });
  } catch (err) {
    console.error("Error registrando error:", err);
  }
}
